var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatAvater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FF8B3E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85438 12.78C11.7424 12.78 13.1024 13.5267 13.9344 15.02L12.8304 15.916C12.5104 15.212 12.1264 14.716 11.6784 14.428C11.241 14.1293 10.6384 13.98 9.87038 13.98C9.05971 13.98 8.41971 14.1507 7.95038 14.492C7.49171 14.8227 7.26238 15.2493 7.26238 15.772C7.26238 16.1133 7.35304 16.396 7.53438 16.62C7.71571 16.844 8.01438 17.0413 8.43038 17.212C8.85704 17.372 9.44371 17.516 10.1904 17.644C11.5877 17.8787 12.5744 18.2307 13.1504 18.7C13.737 19.1693 14.0304 19.82 14.0304 20.652C14.0304 21.2493 13.8597 21.7773 13.5184 22.236C13.1877 22.684 12.713 23.036 12.0944 23.292C11.4757 23.5373 10.761 23.66 9.95038 23.66C8.88371 23.66 7.97171 23.452 7.21438 23.036C6.46771 22.62 5.89704 22.0653 5.50238 21.372L6.60638 20.476C6.89438 21.1053 7.31571 21.596 7.87038 21.948C8.43571 22.2893 9.13971 22.46 9.98238 22.46C10.8144 22.46 11.4757 22.3107 11.9664 22.012C12.457 21.7027 12.7024 21.2707 12.7024 20.716C12.7024 20.2467 12.489 19.8733 12.0624 19.596C11.6357 19.3187 10.8784 19.084 9.79038 18.892C8.38238 18.6467 7.38504 18.2947 6.79838 17.836C6.21171 17.3773 5.91838 16.7373 5.91838 15.916C5.91838 15.3507 6.07838 14.828 6.39838 14.348C6.71838 13.868 7.17704 13.4893 7.77438 13.212C8.37171 12.924 9.06504 12.78 9.85438 12.78ZM20.1706 23.5H18.5866L15.4666 12.94H16.8426L19.3866 22.492L21.8826 12.94H23.3386L25.8346 22.524L28.3946 12.94H29.6906L26.5866 23.5H25.0026L23.1306 16.652L22.5866 14.268H22.5706L22.0266 16.652L20.1706 23.5Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAvater);
export default __webpack_public_path__ + "static/media/chat-avater.e19fd862f130e8297d95cf4bd141ecfd.svg";
export { ForwardRef as ReactComponent };